import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import Vision from '@/views/AboutView.vue'
import Careers from '@/views/Careers.vue'
import Faq from '@/views/Faq.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/vision',
            name: 'vision',
            component: Vision,
        },
        {
            path: '/careers',
            name: 'careers',
            component: Careers,
        },
        { path: '/faq', name: 'faq', component: Faq },
        // Legacy redirects so old links still work
        { path: '/platform', redirect: '/' },
        { path: '/coaches', redirect: '/' },
        { path: '/about', redirect: '/vision' },
    ],
})
